window.app = window.app || {};
var defaultCurrency = 'KWD';
if (window.market_handle === 'ae'){
  defaultCurrency = "AED";
}


window.app.currencyExchange = {
  el: {
    elementsToObserve: document.querySelectorAll(".modal, #ProductModals"),
    cartForms: document.querySelectorAll(".cart__drawer-form, .cart__form"),
    currencyButtons: document.querySelectorAll("input[name='currency']"),
    currencyFlags: document.querySelectorAll("[data-current-currency-img]"),
    currencyListToggle: document.querySelector(".currency-switcher > button"),
    currencyList: document.querySelector(".currency-switcher__list"),
    priceElements: document.querySelectorAll("[data-price]"),
    currentPriceElements: document.querySelectorAll("[data-current-currency]"),
    localeFormSubmit: document.querySelector(".disclosure__submit__btn"),
    localeForms: document.querySelectorAll('#localization_form-toolbar, .lang-switcher__modal')
  },
  defaultCurrency: "KWD",
  selectedCurrency: "",
  threeDecimalsCurrencies: ["KWD", "BHD"],
  decimals: 3,
  activeCurrency: null,
  currenciesArabicMap: {
    "KWD": "د.ك",
    "KD": "د.ك",
  },

  roundPrice(num, decimals) {
    return Number(Math.round(parseFloat(num + 'e' + decimals)) + 'e-' + decimals).toFixed(decimals);
  },

  convertPriceByValue(value){
    value = typeof value === 'string' ? parseFloat(value.replace(/,/g, "")) : value;
    if (!window.Currency || typeof window.Currency.convert !== 'function') return this.roundPrice(value, this.decimals) + " " + this.activeCurrency;
    let convertedPrice = window.Currency.convert(value, this.defaultCurrency, this.activeCurrency);
    if (isNaN(convertedPrice)) convertedPrice = value;
    convertedPrice = this.roundPrice(parseFloat(convertedPrice), this.decimals) + " " + this.activeCurrency;
    return convertedPrice;
  },

  formatPriceHTML(numericStr, currencySymbol) {
    const parts = numericStr.split('.');
    let html = `<span>${parts[0]}</span>`;
    if (parts[1]) html += `<span>.</span><span>${parts[1]}</span>`;
    if (currencySymbol) html += ` <span class="price-currency">${currencySymbol}</span>`;
    return html;
  },

  convertPrices(elements = this.el.priceElements) {
    if (elements.length){
      elements.forEach((priceElement) => {
        const price = parseFloat((priceElement.dataset.price || "0").replace(/,/g, ""));

        if (!priceElement.classList.contains('price--currency-converted')) {
          const isOriginal = priceElement.getAttribute('data-type') === 'product-item-original';
          const locale = window.Shopify && window.Shopify.locale;
          const currencySymbol = locale === 'ar'
            ? (this.currenciesArabicMap && this.currenciesArabicMap[this.activeCurrency]) || this.activeCurrency
            : this.activeCurrency;

          let numericStr;
          if (this.activeCurrency == this.defaultCurrency) {
            numericStr = this.roundPrice(price, this.decimals);
            priceElement.innerHTML = this.formatPriceHTML(numericStr, isOriginal ? null : currencySymbol);
          } else if (window.Currency && typeof window.Currency.convert === 'function') {
            let convertedPrice = window.Currency.convert(price, this.defaultCurrency, this.activeCurrency);
            if (isNaN(convertedPrice)) convertedPrice = price;
            numericStr = this.roundPrice(parseFloat(convertedPrice), this.decimals);
            priceElement.innerHTML = this.formatPriceHTML(numericStr, isOriginal ? null : currencySymbol);
          }

          if (numericStr) {
            const wrapper = priceElement.parentElement;
            if (wrapper && wrapper.getAttribute('role') === 'text') {
              wrapper.setAttribute('aria-label', isOriginal ? numericStr : `${numericStr} ${currencySymbol}`);
            }
          }
        }
        priceElement.classList.add('price--currency-converted');
      });
    }
    this.el.priceElements = [...this.el.priceElements, ...elements];
  },
  htmlChangesObserver(element) {
    const observer = new MutationObserver((records, observer) => {
      let prices = element.querySelectorAll("[data-price]");
      // let elementToObserve = element.querySelector("[data-blocks-holder]");
      this.convertPrices(prices);
    });
    observer.observe(element, { subtree: true, childList: true });
  },

  cartChangesObserver(element){
    const observer = new MutationObserver((records, observer) => {
      let prices = element.querySelectorAll(".money");

      if (prices.length){
        prices.forEach(priceElement => {
          const price = parseFloat(priceElement.innerHTML.replace(/\(|\)/g, "").replace(/,/g, ""));
          if (!isNaN(price)) priceElement.setAttribute('data-price', price);
        })
        // this.convertPrices(prices);
        observer.disconnect();
      }
    });
    observer.observe(element, { subtree: true, childList: true });
  },


  activateCurrency(currency) {
    try { localStorage.setItem("currency", currency); } catch(e) {}
    this.activeCurrency = currency;
    this.setDecimals();
    // this.convertPrices();
    // this.el.currentPriceElements.forEach((element) => {
    //   element.textContent = currency;
    // })

  },

  setDecimals(){
    if (this.threeDecimalsCurrencies.includes(this.activeCurrency)){
      this.decimals = 3;
    }else{
      this.decimals = 2;
    }
  },

  aiodConvert(){
    let prices = document.querySelectorAll(".money");
    if (prices.length){
      prices.forEach(priceElement => {
        const price = parseFloat(priceElement.innerHTML.replace(/\(|\)/g, "").replace(/,/g, ""));
        priceElement.setAttribute('data-price', price);
      })
      this.convertPrices(prices);
    }
  },

  init() {

    let savedSearchUrl = null;
    try {
      savedSearchUrl = sessionStorage.getItem('currency_change_search_url');
      if (savedSearchUrl) sessionStorage.removeItem('currency_change_search_url');
    } catch(e) {}
    if (savedSearchUrl) {
      const savedPath = savedSearchUrl.split('?')[0];
      if (window.location.pathname === savedPath && !window.location.search.includes('q=')) {
        window.location.replace(savedSearchUrl);
        return;
      }
    }

    this.el.elementsToObserve.forEach((el) => {
      this.htmlChangesObserver(el);
    });

    this.el.cartForms.forEach((el) => {
      this.cartChangesObserver(el);
    });

    try {
      const saved = localStorage.getItem("currency");
      if (saved !== null) {
        this.activeCurrency = saved;
      } else {
        this.activeCurrency = this.defaultCurrency;
        localStorage.setItem("currency", this.defaultCurrency);
      }
    } catch(e) {
      this.activeCurrency = this.defaultCurrency;
    }

    this.setDecimals();
    this.convertPrices();
    this.el.currentPriceElements.forEach((element) => {
      this.activateCurrency(this.activeCurrency);
      element.textContent = this.activeCurrency;
    })
    // if (this.el.currencyListToggle) {
    //   this.el.currencyListToggle.addEventListener("click", () => {
    //     this.el.currencyList.classList.toggle("active");
    //   });
    // }

    if (this.el.currencyButtons) {
      this.el.currencyButtons.forEach((btn) => {
        const currency = btn.value;
        if (this.activeCurrency === currency){
          btn.checked = true;
        }
        btn.addEventListener("change", () => {
          this.selectedCurrency = currency;
          // if (this.el.currencyList) {
          //   this.el.currencyList.classList.remove("active");
          // }
          // this.activateCurrency(currency);
          // this.el.currencyButtons.forEach((tempBtn) => {
          //   tempBtn.classList.remove('active');
          // });
          // btn.classList.add('active');

          // this.el.currencyFlags.forEach((flag) => {
          //   if (flag.dataset.curr == this.activeCurrency){
          //     flag.style.display = 'inline-block';
          //   }else{
          //     flag.style.display = 'none';
          //   }
          // })
        });
      });
    }

    if (this.el.localeForms){
      this.el.localeForms.forEach((form) => {
        form.addEventListener('submit', (e) => {
          if (this.selectedCurrency !== ''){
            console.log('currency: ' + this.selectedCurrency);
            e.preventDefault();
            this.activateCurrency(this.selectedCurrency);

            if (this.selectedCurrency == 'AED') {
              localStorage.setItem("market_change", 'ae');
            }else{
              localStorage.setItem("market_change", 'kw');
            }

            if (window.location.search.includes('q=')) {
              try { sessionStorage.setItem('currency_change_search_url', window.location.pathname + window.location.search); } catch(e) {}
            }

            form.submit();

          }
        })
      });
    }

    this.el.currencyFlags.forEach((flag) => {
      if (flag.dataset.curr == this.activeCurrency){
        flag.style.display = 'inline-block';
      }else{
        flag.style.display = 'none';
      }
    })

    document.addEventListener("recommendations:loaded", (evt) => {
      let prices = evt.detail.section.querySelectorAll("[data-price]");
      this.convertPrices(prices);
    });

    document.addEventListener("modalOpen", (e) => {
      const targetNode = e.target.activeElement;
      let prices = targetNode.querySelectorAll("[data-price]");
      this.convertPrices(prices);
    });
  },
};

window.addEventListener("DOMContentLoaded", () => {
  window.app.currencyExchange.init();


});
function cs_discount_applied_Cart() {
  window.app.currencyExchange.aiodConvert();
}
